<script setup>
import {computed, ref} from "vue";

const props = defineProps({
  value: {
    type: Number,
    default: 100
  },
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  }
})

const emit = defineEmits(['update:value'])

const sliderHandle = ref(null)
const widthRate = computed(() => {
  return (props.value - props.min) / (props.max - props.min) * 100
})

const startDrag = (event) => {
  event.preventDefault()
  const slider = event.target.closest('.relative')
  const isTouchEvent = event.type.startsWith('touch')
  const initialX = isTouchEvent ? event.touches[0].clientX : event.clientX
  const initialScale = props.value

  const handleMove = (moveEvent) => {
    const clientX = isTouchEvent ? moveEvent.touches[0].clientX : moveEvent.clientX
    const deltaX = clientX - initialX
    const sliderWidth = slider.offsetWidth
    let range = initialScale + Math.round((deltaX / sliderWidth) * 100)
    if (range < props.min) {
      range = props.min
    } else if (range > props.max) {
      range = props.max
    }

    emit('update:value', range)
  }

  const handleEnd = () => {
    if (isTouchEvent) {
      document.removeEventListener('touchmove', handleMove)
      document.removeEventListener('touchend', handleEnd)
    } else {
      document.removeEventListener('mousemove', handleMove)
      document.removeEventListener('mouseup', handleEnd)
    }
  }

  if (isTouchEvent) {
    document.addEventListener('touchmove', handleMove, {passive: false})
    document.addEventListener('touchend', handleEnd)
  } else {
    document.addEventListener('mousemove', handleMove)
    document.addEventListener('mouseup', handleEnd)
  }
}
</script>

<template>
  <div class="flex items-center gap-4">
    <div class="w-full h-2 bg-gray-200 rounded-full relative">
      <div
        class="h-full bg-primary rounded-full"
        :style="{ width: `${(widthRate) / 100 * 100}%` }"
      />
      <div
        ref="sliderHandle"
        class="w-8 h-8 bg-white border-2 border-primary rounded-full absolute top-1/2 -translate-y-1/2 cursor-grab"
        :style="{ left: `calc(${(widthRate) / 100 * 100}% - 10px)` }"
        @mousedown="startDrag"
        @touchstart="startDrag"
      />
    </div>
    <span class="text-sm font-medium w-8">{{ value }}%</span>
  </div>
</template>

<style scoped>

</style>
